export default function Methodology() {
  const pillars = [
    {
      icon: 'ri-palette-line',
      title: 'Técnica',
      items: [
        'Personagem',
        'Corpo',
        'Voz',
        'Ação',
        'Ritmo',
        'Presença cênica'
      ]
    },
    {
      icon: 'ri-flashlight-line',
      title: 'Energia',
      items: [
        'Mapeamento vibratório',
        'Limpeza energética',
        'Proteção',
        'Telepatia pessoal',
        'Telepatia coletiva',
        'Consciência energética'
      ]
    },
    {
      icon: 'ri-brain-line',
      title: 'Mental & Emocional',
      items: [
        'Estado zero',
        'Ação perfeita',
        'Foco',
        'Disciplina',
        'Liberação de bloqueios',
        'Eliminação de autossabotagem'
      ]
    }
  ];

  return (
    <section id="metodologia" className="py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-8">
        <div className="text-center mb-20">
          <h2 className="text-4xl lg:text-5xl font-black text-[#262364] mb-6">
            Metodologia AAPEQ
          </h2>
          <p className="text-lg text-gray-700 max-w-3xl mx-auto">
            Uma abordagem integrada que une técnica, energia e consciência para transformação completa
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {pillars.map((pillar, index) => (
            <div
              key={index}
              className="bg-white rounded-3xl p-10 shadow-sm hover:shadow-xl transition-all duration-300 group cursor-pointer"
            >
              <div className="flex flex-col items-center mb-8">
                <div className="w-24 h-24 flex items-center justify-center mb-6">
                  <i className={`${pillar.icon} text-6xl text-[#F05954]`}></i>
                </div>
                <div className="w-1 h-10 bg-[#262364]"></div>
              </div>
              
              <h3 className="text-2xl font-black text-[#262364] text-center mb-6">
                {pillar.title}
              </h3>
              
              <ul className="space-y-3">
                {pillar.items.map((item, idx) => (
                  <li key={idx} className="flex items-start gap-3 text-sm text-gray-600">
                    <i className="ri-checkbox-circle-fill text-[#F05954] text-lg flex-shrink-0 mt-0.5"></i>
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <p className="text-base text-gray-700 italic max-w-2xl mx-auto">
            "Fundada em técnica, energia e consciência — três pilares inseparáveis para a alta performance artística e humana."
          </p>
        </div>
      </div>
    </section>
  );
}
